export default {
  // This constant is used by elements that are scrollTo targets to adjust to fixed headers. Subtracting this value
  // from the y position of the element will clear all header layouts currently on the site (biggest being mobile true modify)
  HEADER_CLEARANCE: 240,
  //  If you change this const, please change in _settings.scss @ $header-height
  HEIGHT_OF_PROGRESS_BAR_DESKTOP: 108,
  //  If you change this const, please change in _settings.scss @ $mobile-header-height, $mobile-progress-bar-height
  HEIGHT_OF_PROGRESS_BAR_MOBILE: 54 + 69,
};
